import React, { Component } from 'react';
import { Waypoint } from 'react-waypoint';
import * as Scroll from 'react-scroll';
import Media from 'react-media';
import { AnalyticsConsumer } from '../../providers/AnalyticsProvider';
import withClickAnalytics from '../../enchancers/with-click-analytics';
import ScreenSection from '../screen-section/ScreenSection';
import ContentContainer from '../content-container/ContentContainer';
import SectionTitle from '../section-title/SectionTitle';
import Button from '../button/Button';

import MainSlider from '../main-slider/MainSlider';

import styles from './ArticlesScreen.module.scss';

import paperBackground from './assets/article.jpg';

import slide1 from './assets/1.png';
import slide1x2 from './assets/1@2x.png';
import slide2 from './assets/2.png';
import slide2x2 from './assets/2@2x.png';
import slide3 from './assets/3.png';
import slide3x2 from './assets/3@2x.png';

const slides = [
  {
    image: {
      normal: slide1,
      double: slide1x2,
    },
    link:
      'https://www.wall-street.ro/articol/Real-Estate/238895/p-anunturi-imobiliare-pe-flatfy-ro.html',
  },
  {
    image: {
      normal: slide2,
      double: slide2x2,
    },
    link:
      'https://forbes.kz/process/property/kak_izmenilis_tsenyi_na_novostroyki_kazahstana_za_osen_2018/',
  },
  {
    image: {
      normal: slide3,
      double: slide3x2,
    },
    link:
      'https://www.milligazete.com.tr/haber/1685581/flatfy-agustos-ayina-ait-turkiye-emlak-verileri',
  },
];

const TrackedButton = withClickAnalytics({
  category: 'article',
  defaultAction: 'btn_click',
})(Button);

class ArticlesScreen extends Component {
  state = {
    currentSlidePage: 0,
  };

  isSliderInViewport = false;
  isViewed = false;

  handleSliderEnterViewport = (sendAction) => () => {
    const { currentSlidePage } = this.state;
    this.isSliderInViewport = true;
    sendAction('img', currentSlidePage);
  };

  handleSliderLeaveViewport = () => () => {
    this.isSliderInViewport = false;
  };

  handleSlideChange = (sendAction) => ({ page, count }) => {
    if (page < 0 || page > count - 1) {
      return;
    }

    this.setState({
      currentSlidePage: page,
    });

    if (this.isSliderInViewport) {
      sendAction('img', page);
    }
  };

  render() {
    const { id } = this.props;
    return (
      <ScreenSection id={id} theme="light" background={paperBackground}>
        <ContentContainer width="narrow">
          <Media query="(max-width: 960px)">
            {(isMobile) => (
              <div className={styles.root}>
                <div className={styles.leftCol}>
                  <SectionTitle>
                    Articles
                    <br />
                    example
                  </SectionTitle>
                  <p className={styles.description}>
                    Examples of using real estate statistics database in the articles by our
                    partners.
                    <br />
                    <br />
                    To discuss the possibility of creating infographics with other data, send us an
                    email.
                  </p>
                  {!isMobile && (
                    <div className={styles.actionHolder}>
                      <TrackedButton component={Scroll.Link} to="contacts" smooth primary>
                        I want free data
                      </TrackedButton>
                    </div>
                  )}
                </div>

                <div className={styles.rightCol}>
                  <div className={styles.slider}>
                    <AnalyticsConsumer category="infographic">
                      {({ sendAction, dataProps }) => (
                        <Waypoint
                          onEnter={this.handleSliderEnterViewport(sendAction)}
                          onLeave={this.handleSliderLeaveViewport(sendAction)}
                        >
                          <MainSlider {...dataProps} onChange={this.handleSlideChange(sendAction)}>
                            {slides.map((item, key) => (
                              <MainSlider.Item key={key}>
                                <img
                                  className={styles.siteImage}
                                  src={item.image.normal}
                                  srcSet={`${item.image.double} 2x`}
                                  alt="item.link"
                                />
                                <a
                                  className={styles.siteLink}
                                  href={item.link}
                                  target="_blank"
                                  rel="noreferrer noopener nofollow"
                                >
                                  {item.link}
                                </a>
                              </MainSlider.Item>
                            ))}
                          </MainSlider>
                        </Waypoint>
                      )}
                    </AnalyticsConsumer>
                  </div>
                </div>
                {isMobile && (
                  <div className={styles.actionHolder}>
                    <TrackedButton component={Scroll.Link} to="contacts" smooth primary>
                      I want free data
                    </TrackedButton>
                  </div>
                )}
              </div>
            )}
          </Media>
        </ContentContainer>
      </ScreenSection>
    );
  }
}

export default ArticlesScreen;
